import React from "react";
import CommonUtil from "../../../../../utils/CommonUtil";
import PageComponent from "../../PageComponent";
import Occurrences from "./Occurrences";

class OccurrencesContainer extends PageComponent {
  constructor(props) {
    super(props);
    this.infoWidgetImage = props.infoWidgetImage;
    this.state = {
      occurrences: []
    };

    this.viewType = "barchart";
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadOccurrences();
  }

  loadOccurrences = () => {
    throw new Error("loadOccurrences must be implemented!");
  };

  occurrenceMapper = element => {
    throw new Error("occurrenceMapper must be implemented!");
  };

  xDataKey = () => undefined;

  yDataKey = () => undefined;

  onOccurrencesLoaded = data => {
    let occurrences = CommonUtil.getDataContent(data);

    if (occurrences) {
      occurrences = occurrences.map(this.occurrenceMapper);
    }

    this.setState({ occurrences: occurrences });
  };

  onOccurrenceClick = () => {
    return this.props.onOccurrenceClick;
  };

  render() {
    return (
      <Occurrences
        label={this.getComponentTitle()}
        occurrences={this.state.occurrences}
        onOccurrenceClick={this.onOccurrenceClick()}
        xDataKey={this.xDataKey()}
        yDataKey={this.yDataKey()}
        viewType={this.viewType}
        infoWidgetImage={this.infoWidgetImage}
      />
    );
  }
}
export default OccurrencesContainer;
